const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/person.ts';
import { MetaKatItem } from '@cistec/common_web/defs/kisim';

export const findRelationKey = (relationTypes: MetaKatItem[], term: string | undefined) => {
    // standardAnswer - in kisim the "angehörigen" tab is meant to be generally 'related'
    // if 'related' doesn't exist we choose the last item of the list

    const relationTypeRelated = relationTypes.find(item => item.FKEY === 'Related');
    const lastRelationType = relationTypes.slice(-1)[0];

    const defaultKey = relationTypeRelated?.FKEY || lastRelationType?.FKEY;

    if (!term) {
        return defaultKey;
    }

    // the given term in Kisim might differ in case and even wording
    const regex = new RegExp(term, 'i');
    const relationType = relationTypes.find(item => item.FKEY.match(regex));
    return relationType?.FKEY || defaultKey;
};
